<template>
  <a-card
    :loading="loading"
    :body-style="{
      padding: '39px 21px 30px 19px',
      borderRadius: '10px',
      boxShadow: '0px 5px 10px 0px rgba(35,35,35,0.05)',
      height: '390px',
    }"
    :bordered="false"
  >
    <div class="chart-card-header" v-if="title">
      <div class="meta">
        <span class="chart-card-title">{{ title }}</span>
        <span class="chart-card-action">
          <slot name="action"></slot>
        </span>
      </div>
    </div>
    <div class="chart-card-content">
      <div style="height: 100%">
        <div
          style="display: flex; flex-direction: row; justify-content: space-between; align-items: center;height: 77px"
          v-if="needNum"
        >
          <div class="total">
            <span>{{ total }}</span>
          </div>
          <div class="info">
            <span>{{ info }}</span>
          </div>
        </div>
        <slot name="content"></slot>
      </div>
    </div>
    <div class="chart-card-footer">
      <div class="field">
        <slot name="footer"></slot>
      </div>
    </div>
  </a-card>
</template>

<script>
export default {
  name: 'ChartCard',
  props: {
    title: {
      type: String,
      default: '',
    },
    total: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    info: {
      type: String,
      default: '',
    },
    needNum: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style lang="less" scoped>
.chart-card-header {
  position: relative;
  overflow: hidden;
  width: 100%;
  .meta {
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 34px;
    color: rgba(0, 0, 0, 0.45);
    font-size: 14px;
    line-height: 22px;
  }
}

.chart-card-action {
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 0;
}

.chart-card-footer {
  padding-top: 9px;
  margin-top: 8px;

  > * {
    position: relative;
  }

  .field {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0;
  }
}

.chart-card-content {
  margin-bottom: 12px;
  height: 100%;
  width: 100%;

  .content-fix {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
  }
}
.chart-card-title {
  width: 78px;
  height: 19px;
  font-size: 20px;
  font-family: Alibaba PuHuiTi;
  font-weight: 500;
  color: #212d40;
  line-height: 18px;
}
.total {
  overflow: hidden;
  word-break: break-all;
  white-space: nowrap;
  margin-top: 43px;
  margin-bottom: 32px;
  margin-left: 22px;
  width: 98px;
  height: 30px;
  font-size: 36px;
  font-family: Akzidenz-Grotesk BQ Extra Conde;
  font-weight: bold;
  color: #216aff;
  line-height: 27px;
}

.info {
  width: 120px;
  height: 15px;
  margin-right: 21px;
  font-size: 15px;
  font-family: Alibaba PuHuiTi;
  font-weight: 500;
  color: #69737f;
  line-height: 18px;
  text-align: center;
}
</style>
